module.exports = __webpack_public_path__ + "img/size_2.65c1b4f6.png";